import { render, staticRenderFns } from "./tag-create-edit-modal.vue?vue&type=template&id=7a72415b"
import script from "./tag-create-edit-modal.vue?vue&type=script&lang=js"
export * from "./tag-create-edit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports